/* ==========================================================================
   OFC 2.0 - Motion y velocidad percibida (24-09-2026)

   Todo progresivo: si el navegador no soporta algo, la tienda funciona
   igual, solo sin el efecto.

   1. REVEAL: fade escalonado al entrar en pantalla.
   2. HEADER COMPACTO + medida en vivo de su altura (ResizeObserver) para
      que la barra del buscador se pegue justo debajo, siempre.
   3. PREFETCH al pasar el mouse 65 ms sobre un link interno.
   4. BOTON AGREGAR con estado y rebote del carro.
   5. CONTADORES de la seccion de cifras.
   6. IMAGENES: cada <img> parte invisible sobre un fondo gris (skeleton) y
      aparece con fade cuando termina de cargar. Si JS no corre, el CSS
      las muestra igual (html.no-js).
   7. CORTINA DE SKELETON al cambiar de pagina: al hacer clic en un link
      interno, en vez de quedarse en blanco, se ve la forma de la pagina
      que viene. Con View Transitions ademas se funde.
   ========================================================================== */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.documentElement.classList.remove('no-js');

  function reveal() {
    var nodos = document.querySelectorAll('.ofc2-rv:not(.is-in)');
    if (!nodos.length) return;
    if (reduce || !('IntersectionObserver' in window)) { nodos.forEach(function (n) { n.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        var hermanos = el.parentElement ? Array.prototype.filter.call(el.parentElement.children, function (c) { return c.classList && c.classList.contains('ofc2-rv') && !c.classList.contains('is-in'); }) : [];
        var idx = hermanos.indexOf(el);
        el.style.transitionDelay = (idx > 0 ? Math.min(idx, 8) * 55 : 0) + 'ms';
        el.classList.add('is-in');
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    nodos.forEach(function (n) { io.observe(n); });
  }

  function marcarReveal() {
    var sel = ['.ofc2-slider', '.ofc2-hero__side > *', '.ofc2-cats__grid > li', '.ofc2-trust', '.collection .grid__item', '.product-grid .grid__item', '.ofc-carrusel__item', '.ofc2-portada .ofc2-h2', '.title-wrapper-with-link', '.ofc-conf__cifra', '.ofc-conf__tarjeta', '.ofc-sat__card', '.ofc-seg__item'].join(',');
    document.querySelectorAll(sel).forEach(function (n) { n.classList.add('ofc2-rv'); });
    reveal();
  }

  function header() {
    var h = document.querySelector('.section-header');
    var barra = document.querySelector('.ofc2-barra');
    if (!h) return;
    var tick = false, ultimo = -1;
    function medir() {
      var alto = Math.round(h.getBoundingClientRect().height);
      if (alto !== ultimo) { ultimo = alto; document.documentElement.style.setProperty('--ofc2-header-h', alto + 'px'); }
    }
    function aplicar() {
      var y = window.scrollY || 0;
      var compacto = y > 80;
      h.classList.toggle('ofc2-compact', compacto);
      if (barra) barra.classList.toggle('ofc2-compact', compacto);
      document.documentElement.classList.toggle('ofc2-scrolled', y > 8);
      tick = false; medir();
    }
    window.addEventListener('scroll', function () { if (!tick) { tick = true; window.requestAnimationFrame(aplicar); } }, { passive: true });
    window.addEventListener('resize', medir, { passive: true });
    if ('ResizeObserver' in window) new ResizeObserver(function () { medir(); }).observe(h);
    else { h.addEventListener('transitionend', medir); setInterval(medir, 400); }
    medir(); aplicar();
  }

  function linkInterno(a) {
    if (!a || !a.href) return false;
    if (a.origin !== location.origin) return false;
    if (a.hash && a.pathname === location.pathname) return false;
    if (/\/(cart|checkout|account|search|customer)/.test(a.pathname)) return false;
    if (a.hasAttribute('download') || a.target === '_blank') return false;
    return true;
  }

  function prefetch() {
    var probe = document.createElement('link');
    if (!probe.relList || !probe.relList.supports || !probe.relList.supports('prefetch')) return;
    var conn = navigator.connection;
    if (conn && (conn.saveData || /2g/.test(conn.effectiveType || ''))) return;
    var hechos = {}, timer;
    function ir(a) {
      var url = a.href.split('#')[0];
      if (hechos[url]) return;
      hechos[url] = 1;
      var l = document.createElement('link'); l.rel = 'prefetch'; l.href = url; l.as = 'document';
      document.head.appendChild(l);
    }
    document.addEventListener('mouseover', function (ev) {
      var a = ev.target && ev.target.closest ? ev.target.closest('a') : null;
      if (!linkInterno(a)) return;
      clearTimeout(timer); timer = setTimeout(function () { ir(a); }, 65);
    }, { passive: true });
    document.addEventListener('mouseout', function () { clearTimeout(timer); }, { passive: true });
    document.addEventListener('touchstart', function (ev) {
      var a = ev.target && ev.target.closest ? ev.target.closest('a') : null;
      if (linkInterno(a)) ir(a);
    }, { passive: true });
  }

  function agregar() {
    document.addEventListener('submit', function (ev) {
      var form = ev.target;
      if (!form || !form.matches || !form.matches('form[data-type="add-to-cart-form"]')) return;
      var btn = form.querySelector('[type="submit"]');
      if (!btn) return;
      btn.classList.add('ofc2-adding');
      setTimeout(function () {
        btn.classList.remove('ofc2-adding'); btn.classList.add('ofc2-added');
        var b = document.querySelector('.cart-count-bubble');
        if (b) { b.classList.remove('ofc2-pop'); void b.offsetWidth; b.classList.add('ofc2-pop'); }
        setTimeout(function () { btn.classList.remove('ofc2-added'); }, 1600);
      }, 650);
    }, true);
  }

  function contadores() {
    var nodos = document.querySelectorAll('.ofc-conf__cifra strong');
    if (!nodos.length || reduce || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target; io.unobserve(el);
        var txt = String(el.textContent || '').trim();
        if (!/^[\d.]+$/.test(txt)) return;
        var fin = parseInt(txt.replace(/\./g, ''), 10) || 0;
        if (!fin) return;
        var t0 = null, dur = 1200;
        function paso(t) {
          if (!t0) t0 = t;
          var p = Math.min(1, (t - t0) / dur), ease = 1 - Math.pow(1 - p, 3);
          el.textContent = Math.round(fin * ease).toLocaleString('es-CL');
          if (p < 1) requestAnimationFrame(paso); else el.textContent = txt;
        }
        requestAnimationFrame(paso);
      });
    }, { threshold: 0.5 });
    nodos.forEach(function (n) { io.observe(n); });
  }

  /* ---------- 6. Imagenes con skeleton ---------- */
  function imagenes() {
    function marcar(img) {
      if (img.complete && img.naturalWidth > 0) { img.classList.add('is-loaded'); return; }
      img.addEventListener('load', function () { img.classList.add('is-loaded'); }, { once: true });
      img.addEventListener('error', function () { img.classList.add('is-loaded'); }, { once: true });
    }
    document.querySelectorAll('.card__media .media img, .ofc2-slide__img img, .ofc2-cat__img img, .ofc-car__foto img').forEach(marcar);
    var mo = new MutationObserver(function (ms) {
      ms.forEach(function (m) {
        m.addedNodes.forEach(function (n) {
          if (n.nodeType !== 1) return;
          if (n.matches && n.matches('img')) marcar(n);
          n.querySelectorAll && n.querySelectorAll('.card__media .media img, .ofc-car__foto img').forEach(marcar);
        });
      });
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  /* ---------- 7. Cortina de skeleton entre paginas ---------- */
  function cortina() {
    var c = document.createElement('div');
    c.className = 'ofc2-page-skel'; c.setAttribute('aria-hidden', 'true');
    c.innerHTML = '<div class="page-width"><span class="ofc2-skel ofc2-skel--hero"></span><span class="ofc2-skel ofc2-skel--m"></span><span class="ofc2-skel ofc2-skel--l"></span><span class="ofc2-skel ofc2-skel--s"></span></div>';
    document.body.appendChild(c);
    document.addEventListener('click', function (ev) {
      if (ev.defaultPrevented || ev.button !== 0 || ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.altKey) return;
      var a = ev.target && ev.target.closest ? ev.target.closest('a') : null;
      if (!linkInterno(a)) return;
      /* Si la pagina tarda mas de 120 ms en irse, mostrar la cortina */
      setTimeout(function () { c.classList.add('is-on'); }, 120);
    });
    window.addEventListener('pageshow', function () { c.classList.remove('is-on'); });
  }

  function init() {
    marcarReveal(); header(); prefetch(); agregar(); contadores(); imagenes(); cortina();
    document.addEventListener('shopify:section:load', marcarReveal);
    var mo = new MutationObserver(function () { clearTimeout(mo._t); mo._t = setTimeout(marcarReveal, 120); });
    var main = document.getElementById('MainContent');
    if (main) mo.observe(main, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
